import React, { useState, useEffect } from "react";
import BackToHome from "../BackToHome";
import "./MovieDB.css";

function MovieDB() {
  const [movieDetails, setMovieDetails] = useState([]);

  const rapidApiKey = process.env.REACT_APP_X_RAPIDAPI_KEY;
  
  const url = "https://moviesdatabase.p.rapidapi.com/titles/x/upcoming";
  const options = {
    method: "GET",
    headers: {
      "X-RapidAPI-Key": `${rapidApiKey}`,
      "X-RapidAPI-Host": "moviesdatabase.p.rapidapi.com",
    },
  };

  const getMovieDetails = () => {
    fetch(url, options)
      .then((response) => response.json())
      .then((data) => {
        setMovieDetails(data.results);
      });
  };

  useEffect(() => {
    getMovieDetails();
  }, []);

  // console.log(movieDetails);

  return (
    <>
      <div className="movieDB">
        <h1 className="my-3 text-center text-white">Upcoming Movies</h1>
        <div className="container" style={{ minHeight: "100vh" }}>
          <div className="row justify-content-center">
            {movieDetails.map((eachMovie) => (
              <div
                className="card col-md-4 m-3"
                style={{ width: "18rem", padding: "0" }}
                key={eachMovie.id}
              >
                <img
                  src={
                    eachMovie.primaryImage
                      ? eachMovie.primaryImage.url
                      : "https://dummyimage.com/820X1230/50/ffffff&text=+++600X400+-+BANNER-IMAGE"
                  }
                  className="card-img-top img-fluid"
                  style={{ height: "-webkit-fill-available" }}
                  alt={eachMovie}
                />
                <div className="card-body">
                  <h5 className="card-title">{eachMovie.titleText.text}</h5>
                  <p className="card-text">
                    Release Date: {eachMovie.releaseDate.day}-
                    {eachMovie.releaseDate.month}-{eachMovie.releaseDate.year}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <BackToHome />
      </div>
    </>
  );
}
export default MovieDB;
